export const SET_PUBLIC_USER_BRAND = "SET_PUBLIC_USER_BRAND";
export const SET_PUBLIC_USER_BRAND_REPO = "SET_PUBLIC_USER_BRAND_REPO";
export const SET_PUBLIC_USER_BRAND_RESET = "SET_PUBLIC_USER_BRAND_RESET";

export function setPublicUserBrand(publicUserBrand) {
	return { type: SET_PUBLIC_USER_BRAND, publicUserBrand };
}

export function setPublicUserBrandRepo(publicUserBrandRepo) {
	return { type: SET_PUBLIC_USER_BRAND_REPO, publicUserBrandRepo };
}

export function setPublicUserBrandReset() {
	return { type: SET_PUBLIC_USER_BRAND_RESET };
}
